import {
  imDeleteFromArray,
  imPush,
} from '@client/shared/utils/immutableUtils/immutableUtils';

export const NOTIFICATION_REDUCER_KEY = 'notificationReducer';

/* Action types */
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const CLEAR_ALL_NOTIFICATIONS = 'CLEAR_ALL_NOTIFICATIONS';
export const LOAD_CAMPAIGN_NOTIFICATIONS = 'LOAD_CAMPAIGN_NOTIFICATIONS';
export const SET_NOTIFICATIONS_ERROR = 'SET_NOTIFICATIONS_ERROR';

/* Reducers */
const initialState = {
  notifications: [],
  campaignNotifications: null,
  errors: null,
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      return {
        ...state,
        notifications: imPush(state.notifications, action.payload),
      };
    }
    case CLEAR_NOTIFICATION: {
      return {
        ...state,
        notifications: imDeleteFromArrayByKeyValue(
          state.notifications,
          'id',
          action.payload
        ),
      };
    }
    case CLEAR_ALL_NOTIFICATIONS: {
      return initialState;
    }
    case LOAD_CAMPAIGN_NOTIFICATIONS: {
      return {
        ...state,
        campaignNotifications:
          action.payload.page === 0
            ? action.payload
            : {
                ...action.payload,
                notifications: [
                  ...state.campaignNotifications.notifications,
                  ...action.payload.notifications,
                ],
              },
      };
    }

    case SET_NOTIFICATIONS_ERROR: {
      return { ...state, errors: action.payload };
    }
    default:
      return state;
  }
}

/* Selectors */
export const selectNotifications = (state) => {
  return state[NOTIFICATION_REDUCER_KEY].notifications;
};

/* should be in component lib */
export function imDeleteFromArrayByKeyValue(array = [], key, value) {
  const indexToDelete = array.findIndex((arrayItem) => {
    return arrayItem[key] === value;
  });

  return imDeleteFromArray(array, indexToDelete);
}
